<div>
    <app-my-carousel-swiper [navigation]="true" [config]="carouselConfig">
        <ng-container *ngFor="let iframeSrc of iframes">
            <div class="swiper-slide d-flex justify-content-center p-4" *ngIf="iframeSrc" >
                <div [innerHTML]="iframeSrc"></div>
            </div>
        </ng-container>
    </app-my-carousel-swiper>
</div>
